import api from '../Api';

export const fetchBusinessData = async userId => {
  try {
    const response = await api.get(`/admin/business/${userId}`);
    if (!response?.data) {
      throw new Error('No data received from the server');
    }
    return response.data.business || response.data;
  } catch (error) {
    console.error('Error fetching business data:', error);
    throw error;
  }
};
export const deleteRating = async ratingId => {
  try {
    await api.delete(`/admin/rating/${ratingId}`);
  } catch (error) {
    console.error('Error deleting rating:', error);
    throw error;
  }
};

export const updateBusinessStatus = async (id, action) => {
  try {
    if (action === 'deactivate' || action === 'reactivate') {
      const status = action === 'deactivate' ? 'disable' : 'active';
      await api.patch(`/admin/status/${id}/${status}`);
    } else {
      await api.patch(`/admin/status/${id}`, {
        status: action === 'approve' ? 'Approved' : 'Rejected',
      });
    }
  } catch (error) {
    console.error(`Error ${action} business:`, error);
    throw error;
  }
};

export const processQuotesData = (quotes = []) => {
  if (!Array.isArray(quotes)) {
    console.warn('Expected array for quotes data, received:', quotes);
    return [];
  }

  const dayCount = {};
  quotes.forEach(quote => {
    if (quote?.createdAt) {
      const day = new Date(quote.createdAt).toISOString().split('T')[0];
      dayCount[day] = (dayCount[day] || 0) + 1;
    }
  });

  return [['Day', 'Quotes'], ...Object.entries(dayCount)];
};
